// extracted by css-extract-rspack-plugin
export default {"root":"root-OYnGjQ","svg":"svg-fPXSfR","svgdark":"svgdark-sa9uwa"};